module.exports = __webpack_public_path__ + "static/media/explore_01.0cd45aa3.jpg";